import moment from 'moment';

export enum AUTH_STATUS {
  authenticating = 'authenticating',
  authenticated = 'authenticated',
  anonymous = 'anonymous',
}

export enum AUTHENTICATION_ERROR_TYPES {
  unauthenticated = 'UNAUTHENTICATED',
  ssoUserNotFound = 'S_S_O_USER_NOT_FOUND',
  ssoUserPasswordResetAttempt = 'S_S_O_USER_PASSWORD_RESET_ATTEMPT',
  ssoUserPasswordLoginAttempt = 'S_S_O_USER_PASSWORD_LOGIN_ATTEMPT',
  emailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  subcontractorAlreadyClaimed = 'SUBCONTRACTOR_ALREADY_CLAIMED',
}

// <-- These should be kept in sync with their counterparts in api/src/constants/index
export const AUTH_TOKEN_EXPIRES_AFTER_DURATION = moment.duration(24, 'hours');

export const INCREASED_SECURITY_FEATURES_AUTH_TOKEN_EXPIRES_AFTER_DURATION = moment.duration(
  30,
  'minutes',
);
// -->
